// src/components/Presentation.js
import React from 'react';
import './Presentation.css'; // eventualmente per gli stili

const Presentation = () => {
  return (
    <section className="presentation">
      <h1>Alessandro Cerea</h1>
      <p>
        Work In Progress
      </p>
    </section>
  );
};

export default Presentation;
